import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateFillValue } from '../actions/index'

var $ = window.$

class Select extends Component {
  state = {
    value: ''
  }
  componentDidMount() {
    var self = this
    $(this.$el).chosen().change(function () {
      self.setState((state) => {
        return {
          value: $(this).val()
        }
      })
      this.props.dispatch(updateFillValue(this.state.value))
    });
    this.props.dispatch(updateFillValue(this.state.value))
  }
  componentWillUnmount() {
    $(this.$el).chosen("destroy");
  }
  render() {
    var { answers } = this.props
    var options = answers.map((answer, index) => {
      return <option key={index} value={answer.value || answer}>{answer.text || answer}</option>
    })
    return(
      <div className="simple-single-select">
        //add redux
        <select ref={(chosen) => this.$el = chosen} data-placeholder="Please select an answer" className="chosen-select-no-single"
                name="xmp-answer">
          <option className="title">Please select an answer</option>
          {options}
        </select>
      </div>
    )
  }
}

const Container = connect(() => {return {}})(Select);

export default Container;



// WEBPACK FOOTER //
// ./src/components/Select.js